/**
 * Search Terms API Service
 *
 * RMF Compliance: Search Term View with search terms and match types
 */

import apiClient from './client';

export interface SearchTermItem {
  search_term: string;
  match_type: string | null;
  keyword_text: string | null;
  impressions: number;
  clicks: number;
  conversions: number;
  cost: number;
  ctr: number;
  avg_cpc: number;
  conversions_value: number;
}

export interface GetSearchTermsRequest {
  member_uuid: string;
  campaign_id: string;
  days?: number;
  limit?: number;
}

export interface GetSearchTermsResponse {
  campaign_id: string;
  search_terms: SearchTermItem[];
  total: number;
  date_range: string;
}

/**
 * Get search term performance data for a campaign
 */
export async function getSearchTerms(
  request: GetSearchTermsRequest
): Promise<GetSearchTermsResponse> {
  const response = await apiClient.post<GetSearchTermsResponse>(
    '/search-terms/get',
    {
      member_uuid: request.member_uuid,
      campaign_id: request.campaign_id,
      days: request.days ?? 30,
      limit: request.limit ?? 100,
    }
  );
  return response.data;
}
